export const getCountdowns = (countdown, format) => {
    format = format.toLowerCase();
    const includeDays = format.includes('d');
    const includeHours = format.includes('h');
    const includeMinutes = format.includes('m');
    const includeSeconds = format.includes('s');
    let days = 0;
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    if (includeDays) {
        days = Math.floor(countdown / (24 * 60 * 60));
        countdown %= 24 * 60 * 60;
    }
    if (includeHours) {
        hours = Math.floor(countdown / (60 * 60));
        countdown %= 60 * 60;
    }
    if (includeMinutes) {
        minutes = Math.floor(countdown / 60);
        countdown %= 60;
    }
    if (includeSeconds) {
        seconds = countdown;
    }
    return {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        includeDays: includeDays,
        includeHours: includeHours,
        includeMinutes: includeMinutes,
        includeSeconds: includeSeconds
    };
};
